export default "__VITE_ASSET__DSYb6Lb5__"